<template>
  <a-modal
    :title="audit ? '其他费用审批' : '其他费用详情'"
    :visible="is_show"
    style="top: 20px"
    :width="900"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="is_show = false"
    class="gufiiguy"
  >
    <template slot="footer">
      <a-button type="primary" @click="downloadData" style="float: left"> 导出 </a-button>
      <a-button key="back" @click="is_show = false"> 取消 </a-button>
      <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
      <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
      <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
    </template>
    <div ref="sadsada">
      <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <div class="title">
          <span>基本信息</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="审批标题"
                class="model_span_form"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span>{{ mdl.title }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="审批编号" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="spanClass">{{ mdl.otherCode }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="抄 送 人 " :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="spanClass">{{ mdl.ccName }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="隶属公司" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                <span class="spanClass">{{ mdl.companyName }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="隶属部门" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                <span class="spanClass">{{ mdl.deptName }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="付款方式" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                <span class="spanClass">{{ paymentMap[mdl.paymentMode] }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="支付日期" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                <span class="spanClass">{{ mdl.paymentDate }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="支付对象" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                <span class="spanClass">{{ mdl.paymentObject }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="开户行" :label-col="{ span: 9 }" :wrapper-col="{ span: 15 }">
                <span class="spanClass">{{ mdl.bankOfDeposit }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <!-- <a-row>
				<a-col :span="24" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
					<a-form-item label="银行账户">
						<span class="spanClass">{{ mdl.bankAccount }}</span>
					</a-form-item>
				</a-col>
			</a-row> -->
          <a-row>
            <a-col :span="24">
              <a-form-item label="银行账户" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="spanClass">{{ mdl.bankAccount }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="付款事由" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="spanClass">{{ mdl.paymentDetails }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="特殊备注">
                <span class="spanClass">{{ mdl.remark }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item>
                <span class="spanClass" style="font-size: 16px; font-weight: 700; color: gray">{{
                  typesMap[mdl.types]
                }}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="title">
          <span>评审信息</span>
        </div>
        <div class="content">
          <a-table :data-source="mdl.otherChargeInfos" bordered>
            <a-table-column key="amountDetails" ellipsis="true" title="费用明细" data-index="amountDetails" />
            <a-table-column key="paymentAmount" ellipsis="true" title="支付金额(元)" data-index="paymentAmount" />
            <a-table-column key="remark" ellipsis="true" title="备注" data-index="remark" />
          </a-table>
          <a-row>
            <a-col :span="8">
              <a-form-item label="总 金 额 ">
                <span class="spanClass">{{ mdl.amountTotal }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <div
                  class="view_path_img"
                  v-for="(item, index) in mdl.sysAttachments"
                  :key="index"
                  style="display: flex; justify-content: space-between"
                >
                  <div class="view_path_img_margin"></div>
                  <div class="view_path_img_center">
                    <img :src="item.imgUrl" @click="show_img(index, mdl.sysAttachments)" />
                  </div>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <div class="title" v-if="!audit && recordNumber==1">
          <span>审批记录</span>
        </div>
        <div class="content" v-if="!audit && recordNumber==1">
          <auditModel ref="auditModel"></auditModel>
        </div>
      </a-form>
    </div>
    <preview ref="preview" />
    <!-- 撤销提示 -->
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" />
  </a-modal>
</template>
<script>
import { downLoadPdf  } from '@/utils/index'
import auditModel from './audit.vue'
import { previewFileLists } from '@/utils/preview.js'
import {
  getOtherApply,
  auditTask,
  act_task_audit,
  cover_apply_downlodPdf,
  other_apply_downlodPdf,
} from '@/api/activiti'
import preview from '@/components/module/prview'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import Watermark from '../../../utils/watermark'
const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
export default {
  name: 'LeaveModal',
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    transferModal,
    auditModel,
  },
  data() {
    return {
      recordNumber: 0,
      is_revocation: false,
      result: '',
      comment: '', //驳回原因
      visible: false,
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      confirmLoading: false,
      mdl: {},
      options: [],
      dateFormat: 'YYYY-MM-DD HH:mm',
      formData: {},
      form: this.$form.createForm(this),
      is_show: false,
      record: '',
    }
  },
  created() {},
  methods: {
    	//导出
		downloadData() {
			downLoadPdf('/act/other_apply/downlodPdf?businessKey=' + this.record.businessKey,)
    },
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    },
    download() {
      other_apply_downlodPdf({
        businessKey: this.record.businessKey,
      }).then((res) => {
        console.log(res, 'res111111=====================')
        window.open(exportBaseUrl + '/file/download?path=' + res.data)
      })
    },
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      console.log(row)
      this.$refs.preview.show(row)
    },
    show(record) {
      this.recordNumber = record.recordNumber
      this.record = record
      // record 是任务 如果只是查看可以只传入一个businessKey
      if (this.audit) {
        this.formData = Object.assign({
          taskId: record.id,
          procInstId: record.procInstId,
          procName: record.processDefName,
          businessKey: record.businessKey,
          procDefKey: record.processDefKey,
          applyer: record.applyer,
        })
      }
      getOtherApply(record.businessKey).then((res) => {
        console.log(res, 'res2222=====================')
        if (res.code === 200) {
          const { type } = res.data
          this.mdl = Object.assign(res.data)
          previewFileLists(this.mdl.sysAttachments).then((res) => {
            this.mdl.sysAttachments = res
          })

          this.is_show = true
          this.$nextTick(() => {
            Watermark.set('安联云管家', this.$refs.sadsada)
            if (!this.audit && this.recordNumber==1) {
              this.$refs.auditModel.show(record)
            }
          })
        }
      })
    },
    handleSubmit(result) {
      this.confirmLoading = true
      const formData = this.formData
      formData.result = result
      auditTask(formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.$emit('ok')
            this.is_show = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.record,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
        console.log(this.record)
      }
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
          this.actTask()
        }
      } else if (this.result == 2) {
        this.actTask()
      }
    },
    actTask() {
      act_task_audit({
        taskId: this.record.id,
        procDefKey: this.record.processDefKey,
        procInstId: this.record.procInstId,
        procName: this.record.processName,
        applyer: this.record.applyer,
        result: this.result,
        businessKey: this.record.businessKey,
        comment: this.comment,
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审批成功')
        this.$emit('ok')
        this.is_show = false
        this.is_revocation = false
      })
    },
  },
  watch: {
    /*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-input-disabled {
  color: #000;
  background-color: #fff;
}

/deep/ .ant-select-disabled {
  color: #000;
}

/deep/ .ant-select-selection {
  background-color: #fff;
}
</style>
